import { Fragment, useEffect, useState } from "react";
import "./ReviewsReport.css";
import { useStateValue } from "../../../StateProvider";
import { actionTypes } from "../../../reducer";

const ReviewsReport = ({ reviewsData }) => {
    const [profileData, setProfileData] = useState();
    const [reviewsLast30Days, setReviewsLast30Days] = useState([]);
    const [reviewsLast20, setReviewsLast20] = useState([]);
    const [reviewsMostRelevant, setReviewsMostRelevant] = useState([]);
    const [{ mobileReportView }, dispatch] = useStateValue();
    const reviewsLast30DaysSettings = [
        { label: "Total Reviews", propName: "last30DaysTotalReviews" },
        { label: "Average Rating", propName: "last30DaysAverageRating" },
        { label: "Average Words Per Review", propName: "last30DaysAverageWordsPerReview" },
        { label: "Do Not Have Replies", propName: "last30DaysDoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last30DaysLocalGuideReviews" },
        { label: "Negative Reviews", propName: "last30DaysNegativeReviews" },
        { label: "Negative Reviews Do Not Have Replies", propName: "last30DaysNegativeReviewsDoNotHaveReplies" },
    ];
    const reviewsLast20Settings = [
        { label: "Average Rating", propName: "last20AverageRating" },
        { label: "Average Words Per Review", propName: "last20AverageWordsPerReview" },
        { label: "Do Not Have Replies", propName: "last20DoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last20LocalGuideReviews" },
        { label: "Negative Reviews", propName: "last20NegativeReviews" },
        { label: "Negative Reviews Do Not Have Replies", propName: "last20NegativeReviewsDoNotHaveReplies" },
    ];

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleResize = () => {
        const windowW = window.innerWidth;

        if (windowW >= 992) {
            dispatch({
                type: actionTypes.SET_MOBILE_REPORT_VIEW,
                mobileReportView: "",
            });
        } else {
            dispatch({
                type: actionTypes.SET_MOBILE_REPORT_VIEW,
                mobileReportView: "base",
            });
        }
    };

    useEffect(() => {
        if (reviewsData && reviewsData.data) {
            setProfileData(reviewsData.data.placeInfo);

            if (reviewsData.data.reviews && reviewsData.data.reviews.length) {
                setReviewsLast30Days(reviewsData.data.last30DaysReviews);
                setReviewsLast20(reviewsData.data.last20Reviews);
                setReviewsMostRelevant(reviewsData.data.mostRelevantReviews);
            }

            // //sort by ranking
            // distinctResults = distinctResults.sort(function (a, b) {
            //     return (a.ranking == null) - (b.ranking == null) || -(a.ranking < b.ranking) || +(a.ranking > b.ranking);
            // });
        }
    }, [reviewsData]);

    return (
        <Fragment>
            <div className="reviews-container">
                <div className="table-wrapper border">
                    <table className="items-list reviews-list table table-responsive">
                        <tbody>
                            <tr>
                                <td className="separator-row subrow" colSpan={2}>
                                    <div>
                                        <strong>Review Score</strong>
                                    </div>
                                    {/* <div>
                                        More useful reviews with positive ratings and
                                        meaningful replies can improve your business'
                                        local ranking
                                    </div> */}
                                </td>
                            </tr>
                            <tr>
                                <td className="description">Total Reviews</td>
                                <td className="col-value">
                                    {profileData && profileData.reviews ? (
                                        <button
                                            className="btn btn-link p-0 btn-json-output"
                                            title={profileData.reviews}
                                            //onClick={() => printReviewsList(index, "total")}
                                        >
                                            <span>{profileData.reviews}</span>
                                        </button>
                                    ) : (
                                        <span className="json-output-no-value">0</span>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="description">Average Rating</td>
                                <td className="col-value">
                                    {profileData && profileData.rating ? (
                                        <button
                                            className="btn btn-link p-0 btn-json-output"
                                            title={profileData.rating}
                                            //onClick={() => printReviewsList(index, "total")}
                                        >
                                            <span>{profileData.rating}</span>
                                        </button>
                                    ) : (
                                        <span className="json-output-no-value">0</span>
                                    )}
                                </td>
                            </tr>

                            {/* Reviews Last 30 Days */}
                            <tr>
                                <td colSpan={2} className="separator-row subrow">
                                    <strong>Last 30 Days</strong>
                                </td>
                            </tr>
                            {reviewsData && reviewsData.data && (
                                <Fragment>
                                    {reviewsLast30DaysSettings.map((setting) => {
                                        let propValue = reviewsData.data[setting.propName];

                                        if (typeof propValue == "number" && !isNaN(propValue) && !Number.isInteger(propValue)) {
                                            // propValue = parseFloat(propValue).toFixed(1);
                                            propValue = propValue.toFixed(1);
                                        }

                                        return (
                                            <tr key={setting.label}>
                                                <td className="description">{setting.label}</td>
                                                <td className="col-value">
                                                    {propValue ? (
                                                        <button
                                                            className="btn btn-link p-0 btn-json-output"
                                                            //onClick={() => printReviewsList(index, "last30Days", setting.propName)}
                                                        >
                                                            <span>{propValue}</span>
                                                        </button>
                                                    ) : (
                                                        <span className="json-output-no-value">0</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </Fragment>
                            )}

                            {/* Reviews Last 20 */}
                            <tr>
                                <td colSpan={2} className="separator-row subrow">
                                    <strong>Last 20</strong>
                                </td>
                            </tr>
                            {reviewsData && reviewsData.data && (
                                <Fragment>
                                    {reviewsLast20Settings.map((setting) => {
                                        let propValue = reviewsData.data[setting.propName];

                                        if (typeof propValue == "number" && !isNaN(propValue) && !Number.isInteger(propValue)) {
                                            // propValue = parseFloat(propValue).toFixed(1);
                                            propValue = propValue.toFixed(1);
                                        }

                                        return (
                                            <tr key={setting.label}>
                                                <td className="description">{setting.label}</td>
                                                <td className="col-value">
                                                    {propValue ? (
                                                        <button
                                                            className="btn btn-link p-0 btn-json-output"
                                                            //onClick={() => printReviewsList(index, "last20", setting.propName)}
                                                        >
                                                            <span>{propValue}</span>
                                                        </button>
                                                    ) : (
                                                        <span className="json-output-no-value">0</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </Fragment>
                            )}

                            <tr>
                                <td className="description">Most Relevant Review Age</td>
                                <td className="col-value">
                                    {reviewsData.data.mostRelevantReviewAge ? (
                                        <button
                                            className="btn btn-link p-0 btn-json-output"
                                            //onClick={() => printReviewsList(index, "last30Days", setting.propName)}
                                        >
                                            <span>{reviewsData.data.mostRelevantReviewAge}</span>
                                        </button>
                                    ) : (
                                        <span className="json-output-no-value">0</span>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Fragment>
    );
};

export default ReviewsReport;
